const LIFEPLAN_URL = '/api/lifeplan';

interface LifeplanConfig {
  id: number;
  file_path: string;
  status: 'disconnected' | 'connected' | 'error';
  last_parsed_at: string | null;
  last_error: string | null;
  created_at: string;
  updated_at: string;
}

type LifeplanConfigResponse = LifeplanConfig | { isConfigured: false };

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function getConfig(): Promise<LifeplanConfigResponse> {
  return fetchJson<LifeplanConfigResponse>(`${LIFEPLAN_URL}/config`);
}

export async function configure(filePath: string): Promise<LifeplanConfig> {
  return fetchJson<LifeplanConfig>(`${LIFEPLAN_URL}/config`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ file_path: filePath }),
  });
}

export async function reparse(): Promise<void> {
  await fetchJson(`${LIFEPLAN_URL}/reparse`, { method: 'POST' });
}

export async function getContent(): Promise<{ markdown: string }> {
  return fetchJson<{ markdown: string }>(`${LIFEPLAN_URL}/content`);
}

export async function saveContent(markdown: string): Promise<void> {
  await fetchJson(`${LIFEPLAN_URL}/content`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ markdown }),
  });
}

export type { LifeplanConfig, LifeplanConfigResponse };
